<template>
  <div id="main-app-aside-scroll" class="itms-aside" @mouseover="handleMouseOver" @mouseout="handleMouseOut">
    <div v-if="!isCollapse" class="side-menu-search">
      <!-- 收藏的输入搜索 -->
      <el-input v-model="searchKey" type="text" placeholder="请输入菜单名称">
        <i v-if="!searchKey" slot="suffix" class="el-input__icon el-icon-search" clearable />
        <i v-else slot="suffix" class="el-input__icon el-icon-close" clearable @click="clearSearchKey" />
      </el-input>
    </div>
    <el-scrollbar class="el-menu-vertical">
      <!-- router -->
      <el-menu
        ref="sideMenu"
        menu-trigger="click"
        popper-class="itms-popper-class"
        :collapse="isCollapse"
        mode="vertical"
        :default-active="defaultActive"
        @select="handleSelectMenu"
      >
        <div v-if="favourites && favourites.length" class="common-menu">
          <favourites />
        </div>
        <el-menu-item-group class="itms-menu-item-list">
          <sidebar-item
            v-for="route in routes.children"
            :key="route.url"
            :item="route"
            :level="level + 1"
            :base-path="route.url"
            :search-key="searchKey"
          />
        </el-menu-item-group>
      </el-menu>
    </el-scrollbar>
    <div v-if="!hasNameContainsKey(routes, searchKey)" class="no-data">
      <div class="ematy-icon" />
      <div class="empty-text">No Data</div>
    </div>
  </div>
</template>

<script>
import Hamburger from '@/components/common/Hamburger/index.vue'
import { SappModule } from '@/store/modules/app'
import SidebarItem from './SidebarItem.vue'
import Favourites from './Favourites.vue'
import PerfectScrollbar from 'perfect-scrollbar'
import detailPath from './detailPath.js'
// import ilMenu from '../../menu/src/menu.vue'
// import ilMenuItemGroup from '../../menu/src/menu-item-group.vue'
// 判断一个元素是否在另一个元素内部， 导航可以采用仅按照高度的方式
function inElePosit(subele, ele) {
  let result = false
  const ppos = ele.getBoundingClientRect()
  const spos = subele.getBoundingClientRect()
  if (spos.top > ppos.top && spos.bottom <= ppos.bottom) {
    result = true
  }
  return result
}

export default {
  components: { SidebarItem, Hamburger, Favourites },
  provide() {
    return {
      showToolTip: SappModule.sidebar.showToolTip
    }
  },
  inject: ['features'],
  data() {
    return {
      timer: null,
      showMenu: false,
      subMenus: [],
      searchKey: '',
      level: 0
    }
  },
  computed: {
    favourites() {
      return SappModule.favouriteMenu
    },
    favouritesNav() {
      return !!this.features.favouritesNav
    },
    sidebar() { //! SappModule.sidebar.showSidebar
      return SappModule.sidebar
    },
    isCollapse() {
      return !SappModule.sidebar.opened
    },
    routes() {
      if (SappModule.topMenuActiveIndex < 0) {
        return {}
      }
      return SappModule.menus[SappModule.topMenuActiveIndex]
    },
    activeIndex() {
      return SappModule.topMenuActiveIndex
    },
    defaultActive() {
      /**
       * 此处逻辑修改  需要给每一个detail路由加一个
       * activepath的Meta属性，这样就可以实现每个路由都有相应的高亮menu
       */
      let path = this.$route.path
      try {
        let index = -1
        console.log(this.$route)
        if (this.routes && this.routes.children && this.routes.children.length) {
          index = this.findTopParentIndexByURL(this.routes.children, path)
          console.log('寻找在不在menu里', path, index, this.routes.children)
        }
        if (index < 0) {
          let startPath = ''
          if (this.$route.path.indexOf('st-itms') > -1) {
            startPath = '/st-itms/'
          } else if (this.$route.path.indexOf('st-site') > -1) {
            startPath = '/st-site/'
          } else if (this.$route.path.indexOf('st-idms') > -1) {
            startPath = '/st-idms/'
          } else if (this.$route.path.indexOf('st-3pl') > -1) {
            startPath = '/st-3pl/'
          }
          const afterPath = this.$route.path.replace(startPath, '')

          // 此处需要处理一些逻辑
          let obj = detailPath.find(e => e.path === afterPath)
          console.log('匹配后', afterPath, startPath, obj)
          if (obj) {
            path = startPath + obj.activePath
          } else {
            obj = detailPath.find(e => e.path === this.removeLastSegment(afterPath))
            if (obj) {
              path = startPath + obj.activePath
            }
          }
          // path = '/st-itms/transportation/transportationDocumentServices/transportationDocument'
        }
      } catch (error) {
        console.log(error)
      }

      // 不在菜单中的路径， 找到其父路径
      // if (this.$route.meta.notInMenu) {
      //   const pathArr = this.$route.path.split('/')
      //   pathArr.pop()
      //   if (pathArr.length === 0) {
      //     return null
      //   }
      //   path = pathArr.join('/')
      // }
      console.log('当前激活菜单', path)
      return path
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(val, oldVal) {
        if (SappModule.isSubMenus) {
          const hasItem = (parent) => {
            let result = false
            const children = parent.children
            if (children && children.length > 0) {
              for (let i = 0, len = children.length; i < len; i++) {
                const item = children[i]
                if (item.path === val.path) {
                  result = true
                }
                if (result) {
                  return result
                }
                result = hasItem(item)
                if (result) {
                  return result
                }
              }
              return result
            } else {
              return result
            }
          }
          let subMenu = null
          for (let i = 0, len = SappModule.menus.length; i < len; i++) {
            const item = SappModule.menus[i]
            const result = hasItem(item)
            if (result) {
              subMenu = item
              break
            }
          }
          if (subMenu) {
            this.subMenus = [subMenu]
          }
        }
      }
    }
  },
  created() {},
  mounted() {
    // 获取滚动容器元素
    const scrollContainer = document.getElementById('main-app-aside-scroll')
    if (scrollContainer) {
      // 初始化 PerfectScrollbar
      const ps = new PerfectScrollbar(scrollContainer)
    }
  },
  methods: {
    removeLastSegment(str) {
      // 找到最后一个斜杠的位置
      const lastSlashIndex = str ? str.lastIndexOf('/') : -1

      // 如果找到了斜杠，则返回从开始到最后一个斜杠之前的部分
      // 否则返回原字符串
      return lastSlashIndex !== -1 ? str.substring(0, lastSlashIndex) : str
    },
    findTopParentIndexByURL(menu, url) {
      let i = -1
      menu.forEach((node, index) => {
        if (node.url === url) {
          i = index
        } else if (node && node.children && node.children.length) {
          node.children.forEach((item, m) => {
            if (item.url === url) {
              i = index
            } else if (item && item.children && item.children.length) {
              item.children.forEach((item2, m1) => {
                if (item2.url === url) {
                  i = index
                }
              })
            }
          })
        }
      })
      return i
    },
    clearSearchKey() {
      this.searchKey = ''
    },
    hasNameContainsKey(node, searchKey) {
      if (!node) return false
      if (typeof node.code === 'string' && this.$t(node.code.replace('-', '')).includes(searchKey)) {
        return true
      }
      if (Array.isArray(node.children)) {
        return node.children.some(child => this.hasNameContainsKey(child, searchKey))
      }
      return false
    },
    handleMouseOver() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        if (this.isCollapse) {
          this.showMenu = true
          this.toggleSideBar()
        }
      }, 300)
    },
    handleMouseOut() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        if (this.showMenu) {
          this.showMenu = false
          this.toggleSideBar()
        }
      }, 300)
    },
    handleSelectMenu(index) {
      this.$tracker('FAVORITES_MENU', { path: index }) // 埋点
      console.log('push的路由', index)
      this.$router.push({
        path: `${index}`
      })
    },
    toggleSideBar() {
      SappModule.toggleSideBar()
    }
  }
}
</script>

<style lang="scss">
.hideSidebar{
  .el-scrollbar__wrap{
    overflow-x: hidden;
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      border: none;
      border-radius: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #ccc;
      border-radius: 3px;
      border: none;
    }
  }
}
.el-menu--vertical{
  display: none;
}
.el-icon-close{
  &::before{
    cursor: pointer;
  }
}
.no-data {
  position: absolute;
  top: 168px;
  left: 0;
  right: 0;
  .ematy-icon {
    width: 60px;
    height: 40px;
    background-color: rgba(255, 255, 255, 0.1);
    margin: auto;
    margin-top: 32px;
    background-image: url('~@/assets/img/table-empty/searching.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }

  .empty-text {
    margin-top: 16px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    font-size: 14px;
    color: rgba(134, 141, 159, 1);
  }
}
// @import '../../menu/src/menu.scss';
.sidebar-container .el-menu-item-group__title{
  display: none;
}
.showSidebar{
  .el-submenu{
    padding: 0 8px;
  }
  /deep/.sidebar-container .submenu-title-noDropdown:hover,
  /deep/.sidebar-container .el-submenu__title:hover{
    background-color: #f5f5f6 !important;
  }
  .el-submenu__title{
    padding: 0px 8px 0px 12px;
    border-radius: 6px;
    padding-left: 12px !important;
    &:hover{
      background-color: rgba(245,245,246,1) !important;
    }
  }
  .second-level-sub{
    .el-submenu__title{
      padding-left: 32px !important;
    }
  }
  .el-submenu__title:focus, .el-submenu__title:hover{
    background-color: rgba(245,245,246,1) !important;
  }

}
.second-level{
  span{
    width: calc(100% - 20px);
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.itms-menu-item-list{
  padding-bottom: 40px;
  .el-submenu__title{
    span{
      display: inline-block;
      width: calc(100% - 20px);
      white-space: nowrap;       /* 禁止换行 */
      overflow: hidden;          /* 隐藏溢出内容 */
      text-overflow: ellipsis;   /* 显示省略号 */
    }
  }
  .first-level{
    .el-submenu__title{
      span{
        display: inline-block;
        width: calc(100% - 48px);
        white-space: nowrap;       /* 禁止换行 */
        overflow: hidden;          /* 隐藏溢出内容 */
        text-overflow: ellipsis;   /* 显示省略号 */
      }
      .common-num, .common-selected-num{
        width: unset !important;
      }
    }
  }
  .second-level-sub{
    .el-submenu__title{
      span{
        display: inline-block;
        width: calc(100% - 20px);
        white-space: nowrap;       /* 禁止换行 */
        overflow: hidden;          /* 隐藏溢出内容 */
        text-overflow: ellipsis;   /* 显示省略号 */
      }
      .common-num, .common-selected-num{
        width: unset !important;
      }
    }
  }
  .el-menu-item{
    span{
      display: inline-block;
      width: 90%;
      white-space: nowrap;       /* 禁止换行 */
      overflow: hidden;          /* 隐藏溢出内容 */
      text-overflow: ellipsis;   /* 显示省略号 */
    }
  }
}
.showSidebar{
  .sidebar-container .el-submenu__title:hover{
    background-color: #F5F5F6 !important;
  }
  .el-submenu__icon-arrow{
    right: 8px;
  }
  .el-menu-item{
    border-radius: 6px;
    &:hover{
      background-color: #F5F5F6 !important;
    }
  }
}
.hideSidebar{
  .submenu-title-noDropdown{
    background-color: #ffffff !important;
    span{
      display: none !important;
    }
  }
  // .el-menu-item{
  //   .first-level-menu{
  //     width: 48px;
  //     height: 40px;
  //     border-radius: 8px;
  //     margin-left: 8px;
  //     &.el-submenu__title{
  //       padding: 0 !important;
  //       margin-left: 0px !important;
  //     }
  //     &:hover{
  //       background: rgba(245,245,246,1) !important;
  //     }
  //   }
  // }

  // .is-active{
  //   .first-level-menu{
  //     background: rgba(72,127,247,0.1) !important;
  //     &:hover{
  //       background: rgba(72,127,247,0.1) !important;
  //     }
  //   }
  // }
  .sidebar-container .el-submenu__title:hover{
    background-color: #F5F5F6 !important;
  }
  .el-submenu{
    &.is-active{
      .el-submenu__title{
        background-color: rgba(72,127,247,0.1) !important;
        &:hover{
          background-color: rgba(72,127,247,0.1) !important;
        }
      }
    }
  }
  .sidebar-icon{
    margin: 0 8px !important;
  }
  .el-submenu__title{
    width: 48px;
    height: 40px;
    border-radius: 8px;
    margin-left: 8px;
    &:hover{
      background-color: #F5F5F6;
    }
    span{
      display: none;
    }
  }
  .is-active{
    .el-submenu__title{
    width: 48px;
    height: 40px;
    border-radius: 8px;
    margin-left: 8px;
    &:hover{
      background-color: rgba(72,127,247,0.1);
    }
    span{
      display: none;
    }

  }
  }
  .el-menu-item {
    background-color: #ffffff !important;
    &:hover{
      background-color: #ffffff !important;
    }
    &:focus{
      background-color: #ffffff !important;
    }
    &.is-active{
      background-color: #ffffff !important;
      &:hover{
        background-color: #ffffff !important;
      }
      &:focus{
        background-color: #ffffff !important;
      }
    }
  }

}
.el-menu--popup{
  border-radius: 8px;
  padding: 8px !important;
  .el-submenu__title:hover{
    border-radius: 8px;
    background-color: #F5F5F6;
  }
  .el-menu-item:focus, .el-menu-item:hover{
    border-radius: 6px;
    background-color: #F5F5F6;
  }
  .el-menu-item.is-active{
    background-color: rgba(60,110,240,0.1);
    border-radius: 6px;
    &:hover{
      font-weight: 600;
    }
    &:focus{
      font-weight: 600;
    }
  }
}
</style>
<style lang="scss" scoped>
.el-menu-vertical {
  height: calc(100% - 49px);
}
.side-menu-search {
  position: relative;
  padding: 16px 8px 14px 8px;
  line-height: 1;
  ::v-deep .el-input__inner {
    width: 100%;
    height: 32px;
    background: #F5F5F6;
    border-radius: 20px;
    border: 0;
    color: #333;
    padding: 0 31px 0 12px;
  }
}

</style>
